import { SearchFilterFactory } from './SearchFilterFactory.js';
export function getOrderSearchFilter(search, parsePhoneNumber) {
    if (search === null || search === undefined || search === '') {
        return null;
    }
    const numberFilter = SearchFilterFactory.getIntegerFilter(search);
    if (numberFilter) {
        return {
            number: numberFilter,
        };
    }
    const emailFilter = SearchFilterFactory.getEmailFilter(search);
    if (emailFilter) {
        return {
            email: emailFilter,
        };
    }
    const phoneFilter = SearchFilterFactory.getPhoneFilter(search, parsePhoneNumber);
    if (phoneFilter) {
        return {
            phone: phoneFilter,
        };
    }
    return {
        name: {
            $contains: search,
        },
    };
}
//# sourceMappingURL=searchFilterFactories.js.map